module.exports = __webpack_public_path__ + "static/media/a40.803b90f6.jpg";